import { doc, getDoc } from 'firebase/firestore';
import { APP_DEFAULTS } from '../config';
import { db } from '../components/firebase-config';

const toSpinCount = (value: unknown) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.max(0, Math.floor(value));
  }

  return 0;
};

export const getUserSpinCountByEmail = async (email: string) => {
  const normalizedEmail = email.trim().toLowerCase();
  if (!normalizedEmail) {
    return 0;
  }

  const userRef = doc(db, APP_DEFAULTS.firestoreUsersCollection, normalizedEmail);
  const userSnap = await getDoc(userRef);
  if (userSnap.exists()) {
    return toSpinCount(userSnap.data().spinCount);
  }

  return 0;
};
